module.exports = __webpack_public_path__ + "static/media/delete_image.16ae7a4a.svg";